import gql from "graphql-tag";

export const DELETE_JOB_DEFINITION = gql`
	mutation deleteJobDefinition($input: DeleteJobDefinitionInput!) {
		deleteJobDefinition(input: $input) {boolean}
	}
`;
